import { config } from "./types";
import React, { useMemo, type PropsWithChildren } from "react";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";

export function PurseWalletProvider({ children }: PropsWithChildren) {
  const wallets = useMemo(() => [new PhantomWalletAdapter(), new SolflareWalletAdapter({ network: config.environment === "prod" ? WalletAdapterNetwork.Mainnet : WalletAdapterNetwork.Devnet })], []);
  return <ConnectionProvider endpoint={config.environment === "prod" ? "https://api.mainnet-beta.solana.com" : "https://api.devnet.solana.com"}><WalletProvider wallets={wallets} autoConnect={false} localStorageKey={`megacorp-admin-${config.environment}-sponsor-wallet`}>{children}</WalletProvider></ConnectionProvider>;
}
